<!-- course-review.component.html --> 
<app-header></app-header>
<!-- get start card -->
 <div class="container-fluid">
  <div class="card-container">
  <div class="card">
    <div class="card-content">
      <h1 class="card-title">The Evolving Teaching Landscape</h1>
      <p class="card-subtitle">
         This course explores how early childhood education is transforming to focus on holistic development and meaningful learning. Educators and parents will gain insights into modern teaching practices, 
         understand the importance of age-appropriate learning, and learn how methods like phonics and number sense can replace rote-based approaches.
      </p>
      <button (click)="onGetStarted()" class="btn-primary">Get Started <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right rigtharr" viewBox="0 0 16 16">
               <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"/></svg>
      </button>
    </div>

    <div class="card-image">
      <img src="8.png" alt="Course Image" />
    </div>
  </div>
  </div>

   <!--get start card end-->
<div class="course-review-container">
  
  <div class="course-header">
    <h1>Transforming Early Childhood Education: Holistic Development & Meaningful Learning</h1>
    <div class="course-meta">
      <span class="bestseller">Bestseller</span>
      <span class="rating">4.5 ★ (50,038 ratings)</span>
      <!-- <span class="students">286,483 students</span> -->
    </div>
  </div>
  <div class="course-content">
    <div class="what-youll-learn">
      <h2>What you'll learn</h2>
      <div class="learn-items">
        <div class="learn-column">
          <ul>
            <li>Understand the shift from rote learning to developing number sense in children.</li>
            <li>Recognize the right age for introducing writing skills.</li>
            <li>Learn the importance of holistic development in early childhood.</li>
            <li>Discover why the early years are critical for lifelong learning.</li>
            <li>Compare traditional alphabet teaching methods with phonics-based approaches.</li>
            <li>Explore strategies for engaging young learners effectively.</li>
            <li>Identify common challenges in early childhood education.</li>
          </ul>
        </div>
        <div class="learn-column">
          <ul>
            <li>Reflect on your current teaching practices and areas for improvement.</li>
            <li>Gain practical tips for nurturing curiosity and creativity.</li>
            <li>Learn how to foster a love for learning from the earliest years.</li>
            <li>Understand how to balance skill-building with play-based learning.</li>
            <li>Discuss key questions about evolving teaching methods and approaches.</li>
          </ul>
        </div>
      </div>
    </div>

  <div class="course-content">
    <h2>Course content</h2>
    <!-- <div class="sections-meta">52 sections • 499 lectures • 36h 57m total length</div> -->
    <button class="expand-all" (click)="expandAll()">Expand all sections</button>
    
  <div class="section-list">
  <!-- Section 1 -->
  <div class="section-item" [class.expanded]="expandedSections[0]">
    <div class="section-header" (click)="toggleSection(0)">
      <div class="section-title">
        <h3>Introduction to the Evolving Teaching Landscape</h3>
        <span class="lecture-count">2 lectures • 6min</span>
      </div>
      <span class="toggle-icon">{{ expandedSections[0] ? '−' : '+' }}</span>
    </div>

    <div class="section-details" *ngIf="expandedSections[0]">
      <div class="lecture-item">
        <div class="lecture-info">
          <div class="lecture-title">Why Early Childhood Education is Transforming</div>
          <span class="lecture-duration">03:00</span>
        </div>
      </div>
      <div class="lecture-item">
        <div class="lecture-info">
          <div class="lecture-title">Importance of Holistic Development & Meaningful Learning</div>
          <span class="lecture-duration">03:00</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Section 2 -->
  <div class="section-item" [class.expanded]="expandedSections[1]">
    <div class="section-header" (click)="toggleSection(1)">
      <div class="section-title">
        <h3>Moving Beyond Rote Learning</h3>
        <span class="lecture-count">3 lectures • 12min</span>
      </div>
      <span class="toggle-icon">{{ expandedSections[1] ? '−' : '+' }}</span>
    </div>

    <div class="section-details" *ngIf="expandedSections[1]">
      <div class="lecture-item">
        <div class="lecture-info">
          <div class="lecture-title">From Memorization to Number Sense</div>
          <span class="lecture-duration">04:00</span>
        </div>
      </div>
      <div class="lecture-item">
        <div class="lecture-info">
          <div class="lecture-title">Recognizing the Right Age for Writing Skills</div>
          <span class="lecture-duration">04:00</span>
        </div>
      </div>
      <div class="lecture-item">
        <div class="lecture-info">
          <div class="lecture-title">Why Early Years Are Critical for Lifelong Learning</div>
          <span class="lecture-duration">04:00</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Section 3 -->
  <div class="section-item" [class.expanded]="expandedSections[2]">
    <div class="section-header" (click)="toggleSection(2)">
      <div class="section-title">
        <h3>Modern Approaches to Teaching</h3>
        <span class="lecture-count">3 lectures • 14min</span>
      </div>
      <span class="toggle-icon">{{ expandedSections[2] ? '−' : '+' }}</span>
    </div>

    <div class="section-details" *ngIf="expandedSections[2]">
      <div class="lecture-item">
        <div class="lecture-info">
          <div class="lecture-title">Alphabet Teaching: Traditional vs Phonics-Based</div>
          <span class="lecture-duration">05:00</span>
        </div>
      </div>
      <div class="lecture-item">
        <div class="lecture-info">
          <div class="lecture-title">Strategies to Engage Young Learners</div>
          <span class="lecture-duration">04:30</span>
        </div>
      </div>
      <div class="lecture-item">
        <div class="lecture-info">
          <div class="lecture-title">Balancing Play with Skill-Building</div>
          <span class="lecture-duration">04:30</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Section 4 -->
  <div class="section-item" [class.expanded]="expandedSections[3]">
    <div class="section-header" (click)="toggleSection(3)">
      <div class="section-title">
        <h3>Challenges and Opportunities</h3>
        <span class="lecture-count">2 lectures • 10min</span>
      </div>
      <span class="toggle-icon">{{ expandedSections[3] ? '−' : '+' }}</span>
    </div>

    <div class="section-details" *ngIf="expandedSections[3]">
      <div class="lecture-item">
        <div class="lecture-info">
          <div class="lecture-title">Identifying Common Challenges in Early Education</div>
          <span class="lecture-duration">05:00</span>
        </div>
      </div>
      <div class="lecture-item">
        <div class="lecture-info">
          <div class="lecture-title">Reflecting on Current Teaching Practices</div>
          <span class="lecture-duration">05:00</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Section 5 -->
  <div class="section-item" [class.expanded]="expandedSections[4]">
    <div class="section-header" (click)="toggleSection(4)">
      <div class="section-title">
        <h3>Practical Insights & Next Steps</h3>
        <span class="lecture-count">3 lectures • 12min</span>
      </div>
      <span class="toggle-icon">{{ expandedSections[4] ? '−' : '+' }}</span>
    </div>

    <div class="section-details" *ngIf="expandedSections[4]">
      <div class="lecture-item">
        <div class="lecture-info">
          <div class="lecture-title">Tips for Nurturing Curiosity & Creativity</div>
          <span class="lecture-duration">04:00</span>
        </div>
      </div>
      <div class="lecture-item">
        <div class="lecture-info">
          <div class="lecture-title">Fostering a Love for Learning</div>
          <span class="lecture-duration">04:00</span>
        </div>
      </div>
      <div class="lecture-item">
        <div class="lecture-info">
          <div class="lecture-title">Discussion: Evolving Teaching Methods</div>
          <span class="lecture-duration">04:00</span>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
</div>
</div>
</div>

  <!-- Video Player Modal -->
<!-- Add this modal structure (place it at the bottom of your template) -->
<div class="video-modal" *ngIf="showVideoModal">
  <div class="modal-overlay" (click)="closeVideo()"></div>
  <div class="modal-content">
    <button class="close-modal" (click)="closeVideo()">×</button>
    <div class="video-wrapper">
      <iframe
        *ngIf="currentVideo"
        [src]="getSafeVideoUrl(currentVideo)"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
        title="Course video player">
      </iframe>
    </div>
  </div>
</div>
<app-footer></app-footer>